import flagKeys from '@/constants/flagKeys';
import TransactionCenter from '@/views/Performance/TransactionsCenter.vue';

import { Route } from '../../route.model';

const transactionCenter = new Route(
  '/performance/transactions-center',
  'performance-transactions-center',
  TransactionCenter,
  {
    requiresAuth: true,
    isResponsive: true,
    flag: flagKeys.enableListTransactionsManager,
    zendesk: {
      mobile: {
        offsetHorizontal: '4px',
        offsetVertical: '4px'
      }
    },
    navbar: {
      name: 'Transactions Center',
      icon: 'coins'
    },
    pageView: {
      eventLabel: 'Transactions Center'
    }
  }
);

export { transactionCenter };
export default transactionCenter;
